// import { useState } from "react";
// import { ChevronDown, ChevronRight } from "lucide-react";
// import { OrgEmployee } from "../model/teamHierachyModel";

// const getInitials = (name: string) =>
//   name
//     .split(" ")
//     .map((w) => w[0]?.toUpperCase())
//     .join("")
//     .slice(0, 2);

// const roleBadgeClass: Record<string, string> = {
//   RECRUITER: "bg-blue-100 text-blue-700",
//   VIEWER: "bg-gray-100 text-gray-600",
//   ADMIN: "bg-red-100 text-red-700",
// };

// interface OrgNodeProps {
//   member: OrgEmployee;
//   isRoot?: boolean;
// }

// const OrgNode = ({ member, isRoot = false }: OrgNodeProps) => {
//   const [expanded, setExpanded] = useState(true);
//   const hasChildren = member.direct_reports && member.direct_reports.length > 0;

//   return (
//     <div className="flex flex-col items-center">
//       {/* Node card */}
//       <div
//         onClick={() => hasChildren && setExpanded(!expanded)}
//         className={`
//       relative flex items-center gap-3
// rounded-lg border-2 border-green-700 bg-card
// px-3 py-2 sm:px-4 sm:py-2.5
// shadow-sm
// w-[240px] sm:w-[260px]
// mx-auto
//           ${hasChildren ? "cursor-pointer" : ""}
//           ${isRoot ? "border-primary shadow-md" : "border-green-700"}
//         `}
//       >
//         <div
//           className={`
//             flex h-8 w-8 sm:h-9 sm:w-9 shrink-0 items-center justify-center rounded-full text-xs font-bold
//             ${
//               isRoot
//                 ? "bg-green-700 text-white"
//                 : "bg-green-100 text-black-foreground"
//             }
//           `}
//         >
//           {getInitials(member.full_name)}
//         </div>
//         <div className=" min-h-[10vh] flex flex-col items-center justify-center">
//           <p className="text-xs sm:text-sm font-semibold capitalize text-foreground leading-tight truncate max-w-[120px] sm:max-w-[180px]">
//             {member.full_name}
//           </p>
//           <p className="text-xs text-muted-foreground truncate max-w-[140px]">
//             {member.job_title || member.email}
//           </p>
//           <span
//             className={`mt-0.5 inline-block rounded-full px-2 py-0.5 text-[10px] font-medium ${
//               roleBadgeClass[member.role] || roleBadgeClass.VIEWER
//             }`}
//           >
//             {member.role}
//           </span>
//         </div>
//         {hasChildren && (
//           <span className="ml-1 text-muted-foreground">
//             {expanded ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
//           </span>
//         )}
//       </div>

//       {/* Children with tree lines */}
//       {hasChildren && expanded && (
//         <div className="flex flex-col items-center relative mt-4">
//           {/* vertical line from parent */}
//           <div className="w-[2px] h-6 bg-green-700"></div>

//           {/* horizontal connector */}
//           {member.direct_reports.length > 1 && (
//             <div className="absolute top-6 left-0 right-0 h-[2px] bg-green-700"></div>
//           )}

//           {/* children row */}
//           <div className="flex flex-row justify-center items-start gap-10 mt-6">
//             {member.direct_reports.map((child) => (
//               <div
//                 key={child.id}
//                 className="flex flex-col items-center relative"
//               >
//                 {/* vertical connector */}
//                 <div className="w-[2px] h-6 bg-green-700"></div>

//                 <OrgNode member={child} />
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrgNode;

//18.188.73.145:8000/api/v1/candidates/0677ab16-4ad2-4bf5-8934-3251f6516e91/contact
import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { OrgEmployee } from "../model/teamHierachyModel";

const getInitials = (name: string) =>
  name
    .split(" ")
    .map((w) => w[0]?.toUpperCase())
    .join("")
    .slice(0, 2);

const roleBadgeClass: Record<string, string> = {
  RECRUITER: "bg-blue-100 text-blue-700",
  VIEWER: "bg-gray-100 text-gray-600",
  ADMIN: "bg-red-100 text-red-700",
};

interface OrgNodeProps {
  member: OrgEmployee;
  isRoot?: boolean;
}

const OrgNode = ({ member, isRoot = false }: OrgNodeProps) => {
  const [expanded, setExpanded] = useState(true);
  const hasChildren = member.direct_reports && member.direct_reports.length > 0;

  return (
    <div className="flex flex-col items-center">
      {/* Node card */}
      <div
        onClick={() => hasChildren && setExpanded(!expanded)}
        className={`
          relative flex items-center gap-2
          rounded-md border bg-card
          px-2.5 py-1.5
          shadow-sm transition-all duration-150 hover:shadow-md
          w-[220px]
          ${hasChildren ? "cursor-pointer" : ""}
          ${isRoot ? "border-primary shadow-md" : "border-green-700"}
        `}
      >
        <div className="flex flex-col gap-0.5 flex-1 min-w-0">
          {/* Line 1: Avatar + Name */}
          <div className="flex items-center gap-2">
            <div
              className={`
    flex h-7 w-7 shrink-0 items-center justify-center
    rounded-full text-[11px] font-semibold
    leading-none
    ${isRoot ? "bg-green-700 text-white" : "bg-green-100 text-green-900"}
  `}
            >
              {getInitials(member.full_name)}
            </div>
            <p className="text-xs sm:text-sm font-semibold capitalize text-foreground leading-tight truncate">
              {member.full_name}
            </p>
            {hasChildren && (
              <span className="ml-auto text-muted-foreground">
                {expanded ? (
                  <ChevronDown size={14} />
                ) : (
                  <ChevronRight size={14} />
                )}
              </span>
            )}
          </div>
          {/* Line 2: Email + Role */}
          <div className="flex items-center gap-1.5 pl-2">
            <p className="text-xs text-muted-foreground truncate">
              {member.job_title || member.email}
            </p>
          </div>
          <span
            className={`w-fit mt-2 inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium ${
              roleBadgeClass[member.role] || roleBadgeClass.VIEWER
            }`}
          >
            {member.role}
          </span>
        </div>
      </div>

      {/* Children with tree lines */}
      {hasChildren && expanded && (
        <div className="flex flex-col items-center">
          <div className="h-4 w-0.5 bg-green-700" />

          <div className="relative flex flex-col sm:flex-row overflow-x-auto">
            {member.direct_reports!.length > 1 && (
              <div
                className="absolute top-0 h-0.5 bg-green-700 hidden sm:block"
                style={{
                  left: `${100 / (member.direct_reports!.length * 2)}%`,
                  right: `${100 / (member.direct_reports!.length * 2)}%`,
                }}
              />
            )}

            {member.direct_reports!.map((child) => (
              <div key={child.id} className="flex flex-col items-center px-1">
                <div className="h-4 w-0.5 bg-green-700" />
                <OrgNode member={child} />
              </div>
            ))}
          </div>
        </div>
      )}
      {/* {hasChildren && expanded && (
        <div className="flex flex-col items-center">
         
          <div className="h-4 w-0.5 bg-green-700" />

          <div className="flex flex-col gap-2">
            {member.direct_reports!.map((child) => (
              <div key={child.id} className="flex flex-col items-center">
               
                <div className="h-4 w-0.5 bg-green-700" />

                <OrgNode member={child} />
              </div>
            ))}
          </div>
        </div>
      )} */}
    </div>
  );
};

export default OrgNode;
